import {slots_tool} from "./slots_tool";
import {common_utils} from "../common/common_utils";

function Game_5016()
{

}

Game_5016.GAME_SCENE_TYPE_NORMAL = 0;
Game_5016.GAME_SCENE_TYPE_FREE= 1;
Game_5016.GAME_SCENE_TYPE_SPECIAL= 2;

Game_5016.rows = 4;
Game_5016.colum= 5;

Game_5016.parseResult = function(obj, data)
{
      let detail = data.detail;
      obj.hasextra = false
      obj.hasbonuswin = false;
      common_utils.readDataValue(obj,data);
      obj.bet = detail.realBet;
      obj.profit = data.win - detail.realBet

      obj.mapList = []
      obj.wins = []
      obj.hasfree = true
      if(data.isFree != 0)
      {
        obj.isfree = obj.$t('lang.str_t');
      }
      else
      {
        obj.isfree = obj.$t('lang.str_f');
      }
      let map_data = detail.mapData;
      let maps = null;
      if(detail.type === Game_5016.GAME_SCENE_TYPE_SPECIAL)
      {
          maps = map_data["respinMaps"];
      }else
      {
          maps = map_data["maps"];
      }
      if(maps)
      {
          let len = maps.length;
          for(let m = 0;m < len;++m)
          {
               let one_data = maps[m];
               let map = one_data["map"];
               let mapTmp = Game_5016.setMap(map,Game_5016.rows,Game_5016.colum);
               obj.mapList.push(mapTmp);
               let winList = one_data["winList"];
               let winTmp = Game_5016.setWin(winList,detail.bet,Game_5016.colum);
               obj.wins.push(winTmp);
          }
          let wins = obj.wins;
          if(wins && wins.length>0)
          {
              for(let i = 0;i<wins.length;i++)
              {
                  let mapTmp = obj.mapList[i];
                  let winInfos = wins[i];
                  if(winInfos.length>0)
                  {
                      for(let j = 0;j<winInfos.length;j++)
                      {
                          let winInfo = winInfos[j];
                          let WinNum =  winInfo.num;
                          let winIndex= winInfo.win_index;
                          if(winIndex)
                          {
                            for(let m = 0;m<WinNum;m++)
                            {
                                let index = winIndex[m];
                                let item = mapTmp[index];
                                item.isWin = true;
                                mapTmp[index] = item;
                            }

                          }
                      }
                  }
                  obj.mapList[i] = mapTmp;
              }
          }
      }
      // console.log(obj.mapList);
}


Game_5016.setWin = function(winList, bet_chip, maxColum)
{
    let win_list = [];
    let len = winList.length;
    for(let i = 0;i<len;i++)
    {
        let value = winList[i];
        let winItem =  Game_5016.winItemValue(value,bet_chip,maxColum);
        win_list.push(winItem);
    }
    return win_list;
}

Game_5016.winItemValue = function(value, bet_chip, maxColum)
{
    let winInfo = {};
    if(value)
    {
        winInfo.num = value["c"];
        winInfo.win_index = Game_5016.parseWinIndex(value["l"],maxColum);
        winInfo.win_key = value["s"];
        let win = parseInt(value["w"])*bet_chip;
        winInfo.winGold = win;
    }
  return winInfo;
}

Game_5016.parseWinIndex =function(indexList, maxColum)
{
    let newList = [];
    if(indexList == null||indexList.length == 0)
    {
      return newList;
    }
    let len = indexList.length;
    for(let colum = 0;colum<len;colum++)
    {
        let index = indexList[colum];
        newList.push(index*maxColum+colum);
    }
    return newList;
}

Game_5016.setMap = function(map, rows, colum)
{
    let mapTmp = [];
    for (var j = 0; j < rows; j++)
    {
      for (var i = 0; i < colum; i++)
      {
          let value = map[i][j];
          let obj = Game_5016.splitItemValue(value);
          mapTmp.push(obj)
      }
    }
    return mapTmp;
}

Game_5016.splitItemValue = function(data)
{
    let item = {};
    let one_map = data.split("_");
    if(one_map&&one_map.length>1)
    {
        for(let i = 0;i < one_map.length;i++)
        {
          let value = one_map[i];
          if(i === 0)
          {
              item.itemValue = value;
          }
          else if(i === 1)
          {
              item.itemNum = parseInt(value);
              item.itemNumStr = value;
          }
          else if(i === 2)
          {
             item.multiple = parseInt(value);
          }
        }
    }
    else
    {
        item.itemValue = data;
        item.itemNum = 1;
        item.multiple = 1;
    }
    item.isWin =  false;
    return item;
}

export {
  Game_5016
};




// WEBPACK FOOTER //
// ./src/components/slots/game_5016.js